<!-- 首页 机构信息双击查看机构详情页面 -->
<template>
  <el-dialog width="80%" :visible.sync="showDialog"   @close="closeDialog" title="" >

    <el-form :model="orgInfoStaticForm" label-width="160px" size="mini" >
      <el-row :gutter="20">
        <el-col  :offset="6" :span="11">
          <el-form-item >
            <strong>{{orgInfoStaticForm.name}}</strong>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Name Of Office :" class="change_label_class">
            <span>{{orgInfoStaticForm.englishName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="统一社会信用代码 :" class="change_label_class">
            <span type="text">{{orgInfoStaticForm.certificateNo}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="驻在地址 :" class="change_label_class">
            <span type="textarea">{{orgInfoStaticForm.address}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Address :" class="change_label_class">
            <span type="text" style="width: 100%;">{{orgInfoStaticForm.englishAddress}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="机构设立时间 :" class="change_label_class">
            <span type="text" style="width: 100%;">{{orgInfoStaticForm.issuedOn}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="国家/地区 :" class="change_label_class">
            <span
              v-for="item in this.utils.country"
              :key="item.alphabetCode"
              :label="item.commonName"
              :value="item.commonName">{{orgInfoStaticForm.headquartersCountry === item.alphabetCode? item.commonName : ""}}
            </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" v-if="!isCulturalCenter">
          <el-form-item label="证照签发时间 :" class="change_label_class">
            <span type="text">{{orgInfoStaticForm.renewalDate}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="代表处机构电话 :" class="change_label_class">
            <span type="text">{{orgInfoStaticForm.telephone}}</span>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <el-table
     :data="personData"
     style="width: 100%">
     <el-table-column
       prop="name"
       label="姓名"
       width="180">
     </el-table-column>
     <el-table-column
       prop="postName"
       label="职务">
     </el-table-column>
     <el-table-column
       prop="sexTabName"
       label="性别">
     </el-table-column>
     <el-table-column
       prop="nationalityName"
       label="国籍">
     </el-table-column>
     <el-table-column
       prop="issuedOn"
       label="任职时间">
     </el-table-column>
     <el-table-column
       prop="mobilePhone"
       label="手机">
     </el-table-column>
     <el-table-column
       prop="cardTypeTabName"
       label="证件类型">
     </el-table-column>
     <el-table-column
       prop="cardNumber"
       label="证件号">
     </el-table-column>
   </el-table>
  </el-dialog>
</template>

<script>
import { findPersonList,exportCountryInfo} from '@/views/base/api/DashBoard'
import dateUtil from '../../../common/js/util';
export default {
  // 组件属性对象
  props: {
    // 同步更新父对象的属性, 是否显示该对话框
    detailDialogVisible: Boolean,
    currentOrgTableRow:Object
  },
  // 组件数据对象
  data() {
    return {
        showDialog: true,
        // 机构信息
        orgInfoStaticForm: {},
        //人员信息
        personData:[],
        isCulturalCenter: false,  // 机构是否是文化中心
    };
  },
  // 页面首次加载数据
  mounted() {

      this.orgInfoStaticForm = Object.assign({}, this.currentOrgTableRow);
      if (this.utils.culturalCenter === this.orgInfoStaticForm.type) {
        this.isCulturalCenter = true
      }
      //查询人员信息
      this.findPersonList(this.orgInfoStaticForm.id,this.isCulturalCenter);
  },
  methods: {
    /**
     * 关闭对话框
     * @param modified 是否有更新
     */
    closeDialog(modified) {
        this.showDialog = false;
        // 子组件向父组件绑定的属性传值
        this.$emit('update:detailDialogVisible', false)
    },
    /**
     * 查询人员信息
     */
     findPersonList(orgID,isCulturalCenter) {
       findPersonList({"orgID": orgID}).then(result => {
         this.personData = result.data;
         this.personData.forEach(row => {
           row.sexTabName = dateUtil.findDictItemValueByItemCode(row.sex, this.utils.sex);
           row.cardTypeTabName = dateUtil.findDictItemValueByItemCode(row.cardType, this.utils.personCardType);
           row.nationalityName = this.dictUtils.getCountryChineseName(row.nationality);
           if (isCulturalCenter && row.post == "Chief Representtative") {
              row.postName = "中心主任"
           }else if(row.post == "Chief Representtative"){
             row.postName = "首席代表";
           }else if(isCulturalCenter&&row.post == "Employees"){
             row.postName = "工作人员";
           }else{
             row.postName = "中方雇员";
           }
         });
         //测试用例-国家表数据导入
         // exportCountryInfo().then(result => {
         // })
       });

     }
  }
};
</script>
<style>
  .change_label_class .el-form-item__label{
    font-weight:bold;

  }
</style>
